<template>
    <div v-if="user">
        <div class="panel panel-success">

            <!-- Default panel contents -->
            <div class="panel-heading">
                <i class="fa fa-bars" aria-hidden="true"></i> MENU CAIXAS
            </div>
            <div class="panel-body" v-if="user.level < 5" >
                <p>
                    <a :href="'#/porta-pon/novo'" class="btn btn-warning btn-block">NOVA PORTA PON</a>
                </p>
                <p>
                    <a :href="'#/fibra/novo'" class="btn btn-warning btn-block">NOVA FIBRA</a>
                </p>
                <p>
                    <a :href="'#/caixa-cto/novo'" class="btn btn-warning btn-block">NOVA CAIXA CTO</a>
                </p>
                <p>
                    <a :href="'#/caixa-pacpon/novo'" class="btn btn-warning btn-block">NOVA CAIXA PACPON</a>
                </p>
                <p>
                    <a :href="'#/caixa-switch/novo'" class="btn btn-warning btn-block">NOVA CAIXA SWITCH</a>
                </p>
                <p>
                    <a :href="'#/splitter/novo'" class="btn btn-warning btn-block">NOVO SPLITTER</a>
                </p>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    props: {
        _id: {
            default: null
        }
    },
    data() {
        return {
            user: null
        };
    },
    beforeMount() {
        this.user = this.$store.state.user;
    }
};
</script>
